
<script>
    export let show = true;
  </script>
  
  {#if show}
    <div class="preloader">
      <div class="loader"></div>
    </div>
  {/if}
  
  <style>
    .preloader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(10, 10, 10, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }
  
    .loader {
      width: 50px;
      height: 50px;
      border: 3px solid #00ffff;
      border-top: 3px solid #ff00ff;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
  
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  </style>
  